export enum DocumentType{
    SELFIE='selfie',
    ID='id_card',
    BUSINESS_CARD='business_id_card'
}